<template>
  <nav class="navbar-default navbar-static-side"
       ref="navigation"
       role="navigation">
    <div class="sidebar-collapse">
      <ul class="nav metismenu" id="side-menu">
        <li class="nav-header">
          <div class="dropdown profile-element">
<!--            <img alt="image" class="rounded-circle" src="../assets/img/profile_small.jpg">-->
            <a data-toggle="dropdown" class="dropdown-toggle" href="#">
              <span class="clear" v-if="$currentUser"> <span class="block m-t-xs"> <strong
                class="font-bold">{{ $currentUser.company }}</strong></span>
                  <span class="block">{{ $currentUser.first_name + ' ' + $currentUser.last_name || $currentUser.username }}</span>
              </span>
            </a>
            <ul class="dropdown-menu animated fadeInRight m-t-xs">
              <li>
                <a href="{!! \App\Helper\RouteFunctionHelper::route('get.webGui.logout') !!}">Abmelden</a>
              </li>
            </ul>
          </div>
          <div class="logo-element">

          </div>
        </li>
        <li :class="{active : current_path === '/dashboard'}">
          <router-link :to="{ name: 'general-dashboard'}">
            <i class="fa fa-th-large"></i>
            <span class="nav-label">Home</span>
          </router-link>
        </li>

<!--ITEMS START-->
        <li v-for="(item,index) in items"
            :key="index"
            :class="{active :  item['key'] === current_route_key}">
            <b-link v-if="item['key'] === current_route_key"
                    v-b-toggle=" item['toggle']">
              <i :class=" item.icon "></i> <span class="nav-label">{{$t('sidebar.'+item['key']+'.label')}}</span> <span class="fa arrow"></span>
            </b-link>
            <b-link v-else
                    :to="{name:item['route_name']}">
              <i :class=" item.icon "></i>
              <span class="nav-label">{{$t('sidebar.'+item['key']+'.label')}}</span>
              <span class="fa arrow"></span>
            </b-link>
          <b-collapse :id="item['toggle'] ? item['toggle'] : null "
                      :visible=" current_route_key === item['key'] ">
            <ul class="nav nav-second-level">
              <li v-for="(value,key) in item['items']"
                  :key="key"
                  @click="updatePage"
                  :class="{active: current_route_key === item['key']}">
                <router-link  :to="{name:value['route']}">
                  {{$t('sidebar.'+current_route_key+'.'+value['key'])}}
                </router-link>
              </li>
            </ul>
          </b-collapse>

        </li>
<!--ITEMS END-->
      </ul>
    </div>
  </nav>
</template>

<script>
  import MainSidebar from "@/mixins/main_sidebar"

  export default {
    name: "luma-sidebar",
    mixins:[MainSidebar],
    // data:()=>({
    //   side_toggle:{},
    // }),
    computed: {
      current_path(){
          const x = this.$route.fullPath
        return x
      }
    },
    methods:{
        updatePage(){
            this.$emit('updatePage',true)
        }
    }
  }
</script>

<style scoped>
.nav li {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/layout/LumaSidebar.vue